import * as ko from 'knockout';
import * as _ from "underscore";
import * as localisationHelper from 'localisationHelper';

// Helpers
import "homeClubBindings";
import "selectTwoBindingConfig";
import "knockoutCustomBindings";

// Models
import { ClubSelectionBase } from "Content/ts/Shared/ClubSelector/ClubSelectionBase";
import { IClubSelectionParams } from "Content/ts/Models/Shared/ClubSelector/IClubSelectionParams";

// Services
import { ConfigurableTextService } from "Scripts/ts/Localisation/ConfigurableTextService";

// Components
import "Content/ts/Shared/BootstrapAlerts/AlertValidation/alert-validation";

export const Deps = {
    LocalisationHelper: localisationHelper
};

export default class HomeClubSelection extends ClubSelectionBase {
    additionalCustomMessages: {
        LabelTitleRequired: string,
        DefaultHomeClubTitle: string,
        SelectHomeClubMessage: string
    };

    formattedDefaultHomeClub: KnockoutComputed<string>;
    shouldDisplayHomeClubSelection: KnockoutComputed<boolean>;

    constructor(params: IClubSelectionParams) {
        super(params);

        // Initialisation Methods
        this.retrieveAdditionalCustomMessages();

        this.additionalComputedMethods();
    };

    private additionalComputedMethods() {
        this.formattedDefaultHomeClub = ko.pureComputed(() => {
            const defaultHomeClubText = this.additionalCustomMessages.DefaultHomeClubTitle;

            return !this.externalIsPropertyRequired() ?
                defaultHomeClubText :
                this.additionalCustomMessages.LabelTitleRequired.replace("{0}", defaultHomeClubText);
        });
    };

    private retrieveAdditionalCustomMessages() {
        this.additionalCustomMessages = {
            DefaultHomeClubTitle: ConfigurableTextService.RetrieveTextSync("DefaultHomeClubTitle"),
            SelectHomeClubMessage: ConfigurableTextService.RetrieveTextSync("SelectHomeClubMessage"),
            LabelTitleRequired: Deps.LocalisationHelper.getString("ValidationMessageResources", "LabelTitleRequired")
        };
    };
}

const componentName = "home-club-selection";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: HomeClubSelection,
    template: { require: `text!/Themes/Default/Content/ts/Shared/ClubSelector/${componentName}.html` }
});